import { gql } from "@apollo/client";

export const GetStockGroups = gql`
  query GetStockGroups(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $orderBy: AtsStckGroupOrder
    $name: String
  ) {
    GetStockGroups(
      token: $token
      after: $after
      customerID: $customerID
      first: $first
      orderBy: $orderBy
      where: { or: [{ groupNameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          groupName
          slNo
          customerID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

//By Ids

export const GetGroupNameByNodeId = gql`
  query GetGroupNameByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckGroup {
        groupName
        slNo
        customerID
      }
    }
  }
`;
